import { create } from 'zustand';

interface CommandPaletteState {
  open: boolean;
  /** Element focus returns to when the palette closes (keyboard a11y). */
  triggerEl: HTMLElement | null;
  openPalette: () => void;
  close: () => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>()((set, get) => ({
  open: false,
  triggerEl: null,
  openPalette: () =>
    set({
      open: true,
      // Captured synchronously at the open call, before the input autofocuses,
      // so Esc returns focus to wherever the user was.
      triggerEl:
        typeof document !== 'undefined' ? (document.activeElement as HTMLElement | null) : null,
    }),
  close: () => {
    const el = get().triggerEl;
    set({ open: false, triggerEl: null });
    el?.focus?.();
  },
}));
